import api from "@/config/axiosConfig";
import { useQuery } from "@tanstack/react-query";
import { Location } from "@/types";
import { SuggestionResponse } from "@/types/ai";

export const useLocationSuggestions = (
  tripName: string,
  existingLocations: Location[]
) => {
  return useQuery({
    queryKey: [
      "locationSuggestions",
      tripName,
      existingLocations.map((loc) => loc.waytora_id),
    ],
    queryFn: () => getLocationSuggestions(tripName, existingLocations),
    enabled: !!tripName && !!existingLocations,
    staleTime: Infinity,
  });
};

const getLocationSuggestions = async (
  tripName: string,
  existingLocations: Location[]
): Promise<SuggestionResponse> => {
  const body = {
    trip_name: tripName,
    locations: existingLocations.map((loc: Location) => ({
      id: loc.waytora_id,
      name: loc.name,
      country: loc.address_components.country,
      origin: loc.origin,
    })),
  };

  const { data } = await api.ai.post("/trip/suggest-locations", body);
  return data;
};
